/**
 * @generated SignedSource<<964c1c954c10ebbc74b1b807d415287e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useCoreBuyerIncentives_item$data = {
  readonly userReturnPolicy: {
    readonly returnDays: number | null;
  } | null;
  readonly " $fragmentType": "useCoreBuyerIncentives_item";
};
export type useCoreBuyerIncentives_item$key = {
  readonly " $data"?: useCoreBuyerIncentives_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"useCoreBuyerIncentives_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "userCountryCode"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "useCoreBuyerIncentives_item",
  "selections": [
    {
      "alias": "userReturnPolicy",
      "args": [
        {
          "kind": "Variable",
          "name": "userId",
          "variableName": "userId"
        }
      ],
      "concreteType": "ReturnPolicy",
      "kind": "LinkedField",
      "name": "returnPolicy",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "includeEuReturns",
              "value": true
            },
            {
              "kind": "Variable",
              "name": "userCountryCode",
              "variableName": "userCountryCode"
            }
          ],
          "kind": "ScalarField",
          "name": "returnDays",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "2d3bd8dc1cbec2e8b0f3009504b9ad77";

export default node;
